globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ContactNew = (function(superClass) {

  utils.extend(ContactNew, superClass);

  function ContactNew() {
    return ContactNew.__super__.constructor.apply(this, arguments);
  }

  $.extend(ContactNew.prototype, {
    init: function() {

      this._initAccordion();

      return ContactNew.__super__.init.apply(this, arguments);
    },

    _initAccordion: function () {
      if ($(".accordion").length == 0)
        return
      var _this = this;
      var options = {
        collapsible: true,
        heightStyle: "content",
        animate: 200,
        active: false,
      };
      $accordion = $(".accordion");
      $accordion.first().accordion(options);
      _this._refreshAccordion();
      $(window).resize(function () {
        _this._refreshAccordion();
      });
    },

    _refreshAccordion: function () {
      if ($(".accordion").length == 0)
        return
      var $accordion = $(".accordion");

      var $content = $accordion.find('.ui-accordion-content'),
        windowHeight = $(window).height(),
        accordionTop = $accordion.offset().top,
        $buttons = $accordion.find('h5'),
        heightTotalButtons = $buttons[0].offsetHeight * $buttons.length,
        heightMax = windowHeight - accordionTop - heightTotalButtons;

      $content.css({
        height: "100%",
        overflowY: 'auto'
      });
    },

    updateView: function(response) {
      if (this.subModal() != undefined) {
        this.subModal().$html.find('.modal-content').replaceWith($(response.html).find('.modal-content'));
      }
    }
  });

  return ContactNew;

})(appCustomerSpace.Modal);
